import React, { useEffect, useMemo, useRef } from 'react';
import './task-list-item.scss';
import { TASK_PRIORITIES, TASK_STATUSES } from '../constants';
import UserCheckmark from '../../../../common/user-checkmark/user-checkmark';
import { getFormattedDate, ONE_DAY } from '../../../../../helpers/dateTime';
import UserService from '../../../../../services/user-service';

const getPillStyle = ({ color }) => ({
    backgroundColor: color
});

const TaskListItem = ({
    openTaskDetails,
    task: {
        id,
        name,
        priority,
        status,
        assignedUserId,
        assignedUserFirstName,
        assignedUserLastName,
        targetDate,
        createdOn,
        createdUserId
    },
    createdTaskId
}) => {
    const ref = useRef();
    const taskPriority = useMemo(() => TASK_PRIORITIES.find(({ value }) => value === priority), [priority]);
    const taskStatus = useMemo(() => TASK_STATUSES.find(({ value }) => value === status), [status]);
    const isNewTask = useMemo(() => Date.now() - createdOn < ONE_DAY, [createdOn]);
    const shouldScroll = useMemo(
        () => id === createdTaskId
            && createdUserId === UserService.getLoggedUser().getId(),
        [createdTaskId, id, createdUserId]
    );

    useEffect(() => {
        if (shouldScroll && ref.current) {
            ref.current.scrollIntoView({ block: 'center' });
            ref.current.className += ' glu-task-list-item--highlighted';
        }
    }, [createdTaskId, shouldScroll]);

    return (
        <div
            className="glu-task glu-content__section glu-content__separator glu-content__separator--inner"
            aria-label="glu-task"
            onClick={openTaskDetails}
            ref={ref}
        >
            <div className="glu-flex glu-flex-col glu-task-container">
                <div className="glu-task-name text-bold">{name}</div>
                <div className="glu-task-pills glu-flex-row">
                    <div
                        className="glu-task-priority glu-pill"
                        style={getPillStyle(taskPriority)}
                    >
                        {taskPriority.label}
                    </div>
                    <div className="glu-task-status glu-pill" style={getPillStyle(taskStatus)}>{taskStatus.label}</div>
                    {isNewTask && <div className="glu-task-new-pill glu-pill">New</div>}
                </div>
                <div className="glu-task-assigned-to">
                    <UserCheckmark
                        label="Assigned to: "
                        ownerId={assignedUserId}
                        userLabel={`${assignedUserFirstName} ${assignedUserLastName}`}
                    />
                </div>
                {targetDate && (
                    <div className="glu-task-date">
                        {`Target date: ${getFormattedDate(targetDate)}`}
                    </div>
                )}
            </div>
        </div>
    );
};

export default TaskListItem;
